export default __webpack_public_path__ + "static/background-9dc6fa29e47b9e082c56529800f3f251.jpg";